import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SidebarProvider } from './contexts/SidebarContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Animals from './pages/Animals';
import Deliveries from './pages/Deliveries';
import BulkDelivery from './pages/BulkDelivery';
import Inventory from './pages/Inventory';
import Feeding from './pages/Feeding';
import Treatments from './pages/Treatments';
import Reports from './pages/Reports';
import Machines from './pages/Machines';
import Costs from './pages/Costs';
import Periods from './pages/Periods';
import Farms from './pages/Farms';
import Admin from './pages/Admin';
import Deaths from './pages/Deaths';
import Slaughters from './pages/Slaughters';
import ContractTemplates from './pages/ContractTemplates';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorDialog from './components/ErrorDialog';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SidebarProvider>
          <Router>
            <Toaster position="top-right" />
            <ErrorDialog />
            <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/animals"
            element={
              <ProtectedRoute>
                <Layout>
                  <Animals />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/deliveries"
            element={
              <ProtectedRoute>
                <Layout>
                  <Deliveries />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/deliveries/bulk"
            element={
              <ProtectedRoute>
                <Layout>
                  <BulkDelivery />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Layout>
                  <Inventory />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/feeding"
            element={
              <ProtectedRoute>
                <Layout>
                  <Feeding />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/treatments"
            element={
              <ProtectedRoute>
                <Layout>
                  <Treatments />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/machines"
            element={
              <ProtectedRoute>
                <Layout>
                  <Machines />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/costs"
            element={
              <ProtectedRoute>
                <Layout>
                  <Costs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/periods"
            element={
              <ProtectedRoute>
                <Layout>
                  <Periods />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/farms"
            element={
              <ProtectedRoute>
                <Layout>
                  <Farms />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/deaths"
            element={
              <ProtectedRoute>
                <Layout>
                  <Deaths />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/slaughters"
            element={
              <ProtectedRoute>
                <Layout>
                  <Slaughters />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contract-templates"
            element={
              <ProtectedRoute>
                <Layout>
                  <ContractTemplates />
                </Layout>
              </ProtectedRoute>
            }
          />
            </Routes>
          </Router>
        </SidebarProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;